import gql from 'graphql-tag';

export const customerFragments = gql`
  fragment customerFragments on Customer {
    id
    unit {
      id
      name
      address
      zip
      city
      email
      mobile
      phone
      isCompany
      canReceiveEhf3
      openedDate
      closedDate
      country {
        code
        name
      }
      highestPriorityIdentity {
        id
        value
        identificator {
          id
          name
        }
      }
      vatRegulation
      foretaksRegisteredSince
    }
    deliveryLocations {
      id
      address
      additionalAddress
      city
      zip
      country {
        code
        name
      }
    }
    creditDays
    reference
    invoiceDeliveryMethod
    autoSendInvoice
    customEmail
    customPhone
    email
    phone
    unofficialName
    efakturaEligible
    efakturaIdentifier
    customerNumber
    customerContacts {
      id
      firstName
      lastName
      phone
      email
      jobTitle
      comment
    }
  }
`;

export const GET_CUSTOMER = gql`
  query customer($id: ID!) {
    customer(id: $id) {
      ...customerFragments,
    }
  },
  ${customerFragments}
`;

export const UPDATE_CUSTOMER = gql`
  mutation updateCustomer(
    $customer: CustomerUpdate!,
  ) {
    updateCustomer(
      input: { customer: $customer }
    ) {
      customer {
        ...customerFragments
      }
    }
  },
  ${customerFragments}
`;
